module.exports = __webpack_public_path__ + "img/12.a6ccf534.jpg";